export function classNames(...args) {
  return args.reduce((acc, next) => {
    return next && next !== '' ? `${acc}${acc !== '' ? ' ' : ''}${next}` : acc;
  }, '');
}
